import { FormattedMessage } from "react-intl";
import {  BsFiletypeDocx, BsFiletypeDoc,BsFiletypePdf, BsFileExcel, BsFiletypeXml } from "react-icons/bs";

export const BASE_URL = process.env.REACT_APP_BASE_URL

export const DATE_FORMAT_SERVER = "yyyy-MM-dd";
export const DATE_FORMAT_DISPLAY = "dd/MM/yyyy";
export const DATETIME_FORMAT_DISPLAY = "dd/MM/yyyy HH:mm";
export const ACCESS_TOKEN = "influencee_access";


export const ROLE_ADMIN = {
    value: "super-admin",
    access_level: 900,
    label: <FormattedMessage id="super_admin" defaultMessage={"Super Admin"} />,
}


export const APP_VERSION = "v0.0.1"

export const POPUP_SMALL = "small";
export const POPUP_MEDIUM = "medium";
export const POPUP_LARGE = "large";
export const POPUP_TYPE_SIDE = "side";
export const POPUP_TYPE_DEFAULT = "default";

export const initialPopupState = {
    size: POPUP_MEDIUM,
    heading: "",
    hideDefaultClose: false,
    contained: true,
    component: null,
    type: "default"
};

export const LANGUAGE_ACCESS = "incluencee_lang"
export const EN = "en"
export const IT = "it"

export const OPTION_YES = {
    value: true,
    label: <FormattedMessage id="yes" defaultMessage={"Yes"} />,
    label: "Yes"
}
export const OPTION_NO = {
    value: false,
    label: <FormattedMessage id="no" defaultMessage={"No"} />,
}

export const OPTIONS_BOOL = [
    OPTION_YES,
    OPTION_NO
]

export const ASSENDING_ORDER = "asc"
export const DESENDING_ORDER = "desc"
export const ORDER_DESCENDING = {
    value: "desc",
    label: <FormattedMessage id="most_recent" defaultMessage={"Most Recent"} />,
}
export const ORDER_ASCENDING = {
    value: "asc",
    label: <FormattedMessage id="least_recent" defaultMessage={"Least Recent"} />,
}

export const SORT_ORDERS = [
    ORDER_DESCENDING,
    ORDER_ASCENDING
]
export const LISTING_LIMIT = 12;


export const USER_ACTIVE = {
    value: "active",
    label: <FormattedMessage id="active" defaultMessage={"Active"} />,
}
export const USER_PENDING = {
    value: "pending",
    label: <FormattedMessage id="pending" defaultMessage={"Pending"} />,
}
export const USER_DISABLED = {
    value: "disabled",
    label: <FormattedMessage id="disabled" defaultMessage={"Disabled"} />,
}

export const USER_STATUS = [
    USER_ACTIVE,
    USER_PENDING,
    USER_DISABLED
]

export const ACTIVE = {
    value: "true",
    label: <FormattedMessage id="active" defaultMessage={"Active"} />,
}
export const DISABLED = {
    value: "false",
    label: <FormattedMessage id="disabled" defaultMessage={"Disabled"} />,
}

export const IS_ACTIVE = [
    ACTIVE,
    DISABLED
]

export const APP_LANGUAGE = "influencee_admin_lang";

export const LANGUAGE_OPTIONS = [
    {
        value: {
            code: "en",
            language: "English"
        },
        label: <>
            <div className="flex items-center justify-start gap-2">
                <img src="/images/flags/us.png" alt="English" className="h-6 w-6" />
                <p className="font-semibold">- EN</p>
            </div></>
    },
    // {
    //     value: {
    //         code: "it",
    //         language: "Italian",
    //     },
    //     label: <>
    //         <div className="flex items-center justify-start gap-2">
    //             <img src="/images/flags/it.png" alt="Italian" className="h-6 w-6" />
    //             <p className="font-semibold">- IT</p>
    //         </div>
    //     </>
    // },
    // {
    //     value: {
    //         code: "zh-hans",
    //         language: "简体中文"
    //     },
    //     label: <>
    //         <div className="flex items-center justify-start gap-2">
    //             <img src="/images/flags/cn.png" alt="Chinese" className="h-6 w-6" />
    //             <p className="font-semibold">- CN</p>
    //         </div>
    //     </>
    // },
]

export const TICKETS_VIEW_NOT_SELECTED = "not-selected"


export const FILE_PDF = "PDF"
export const FILE_XML = "XML"
export const FILE_IMAGE = "IMAGE"
export const FILE_EXCEL = "EXCEL";
export const FILE_WORD = "WORD";

export const SUPPORTED_FILE_FORMATS = [
    { extension: 'pdf', value: FILE_PDF, Icon: BsFiletypePdf },
    { extension: 'xml', value: FILE_XML, Icon: BsFiletypeXml },
    { extension: 'png', value: FILE_IMAGE },
    { extension: 'jpg', value: FILE_IMAGE },
    { extension: 'jpeg', value: FILE_IMAGE }, // Support both .jpg and .jpeg
    { extension: 'xls', value: FILE_EXCEL, Icon: BsFileExcel },  // Excel format
    { extension: 'xlsx', value: FILE_EXCEL, Icon: BsFileExcel }, // Excel format
    { extension: 'doc', value: FILE_WORD, Icon: BsFiletypeDoc },   // Word format
    { extension: 'docx', value: FILE_WORD, Icon: BsFiletypeDocx }  // Word format
];





export const TYPE_INFLUENCER = "influencer"
export const TYPE_AGENCY = "agency"


export const CATEGORIES = [
    {
        label: <FormattedMessage id="actor" defaultMessage={"Actor"} />,
        value: "actor"
    },
    {
        label: <FormattedMessage id="architect" defaultMessage={"Architect"} />,
        value: "architect"
    },
    {
        label: <FormattedMessage id="artist" defaultMessage={"Artist"} />,
        value: "artist"
    },
    {
        label: <FormattedMessage id="beauty" defaultMessage={"Beauty"} />,
        value: "beauty"
    },
    {
        label: <FormattedMessage id="comic" defaultMessage={"Comic"} />,
        value: "comic"
    },
    {
        label: <FormattedMessage id="content_creator" defaultMessage={"Content creator"} />,
        value: "content_creator"
    },
    {
        label: <FormattedMessage id="fashion" defaultMessage={"Fashion"} />,
        value: "fashion"
    },
    {
        label: <FormattedMessage id="food" defaultMessage={"Food"} />,
        value: "food"
    },
    {
        label: <FormattedMessage id="photographer" defaultMessage={"Photographer"} />,
        value: "photographer"
    },
    {
        label: <FormattedMessage id="health_n_fitness" defaultMessage={"Health and Fitness"} />,
        value: "health-and-fitness"
    },
    {
        label: <FormattedMessage id="entrepreneur" defaultMessage={"Entrepreneur"} />,  
        value: "entrepreneur"
    },
    {
        label: <FormattedMessage id="lifestyle" defaultMessage={"Lifestyle"} />,
        value: "lifestyle"
    },
    {
        label: <FormattedMessage id="luxury" defaultMessage={"Luxury"} />,
        value: "luxury"
    },
    {
        label: <FormattedMessage id="parenting" defaultMessage={"Parenting"} />,
        value: "parenting"
    },
    {
        label: <FormattedMessage id="marketing" defaultMessage={"Marketing"} />,
        value: "Marketing"
    },
    {
        label: <FormattedMessage id="medical" defaultMessage={"Medical"} />,
        value: "Medical"
    },
    {
        label: <FormattedMessage id="model" defaultMessage={"Model"} />,
        value: "model"
    },
    {
        label: <FormattedMessage id="music" defaultMessage={"Music"} />,
        value: "music"
    },
    {
        label: <FormattedMessage id="public_figure" defaultMessage={"Public Figure"} />,
        value: "public-figure"
    },
    {
        label: <FormattedMessage id="pets_and_animals" defaultMessage={"Pets and Animals"} />,
        value: "pets-and-animals"
    },
    {
        label: <FormattedMessage id="shopping_retail" defaultMessage={"Shopping and Retail"} />,
        value: "Shopping_retail"
    },
    {
        label: <FormattedMessage id="sport" defaultMessage={"Sport"} />,
        value: "Sport"
    },
    {
        label: <FormattedMessage id="travel" defaultMessage={"Travel"} />,
        value: "travel"
    },
    {
        label: <FormattedMessage id="ugc" defaultMessage={"UGC"} />,
        value: "ugc"
    },
    {
        label: <FormattedMessage id="virtual_influencer" defaultMessage={"Virtual Influencer"} />,
        value: "virtual-influencer"
    },
    {
        label: <FormattedMessage id="wedding" defaultMessage={"Wedding"} />,
        value: "wedding"
    },
    {
        label: <FormattedMessage id="other" defaultMessage={"Other"} />,
        value: "Other"
    },
]

export const AGENCY_CATEGORIES = [
    {
        label: <FormattedMessage id="agency" defaultMessage={"Agency"} />,
        value: "agency"
    },
    {
        label: <FormattedMessage id="e-commerce" defaultMessage={"E-commerce"} />,
        value: "e-commerce"
    },
    {
        label: <FormattedMessage id="other" defaultMessage={"Other"} />,
        value: "other"
    },
]


export const INSTAGRAM = "instagram"
export const TIKTOK = "tiktok"

export const PLATFORMS = [
    {
        label: <FormattedMessage id="instagram" defaultMessage={"Instagram"} />,
        value: INSTAGRAM,
    },
    {
        label: <FormattedMessage id="tiktok" defaultMessage={"Tiktok"} />,
        value: TIKTOK,
    }
]